class ResourcesFilter {
  static init() {

    // missing forEach on NodeList for IE11
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    const filters = document.querySelector('[data-name="resources-filter__form"]');
    if (filters) {
      filters.addEventListener('dropdown-custom-selected', function (evt) {
        evt.target.closest('form').querySelector('input[type="submit"]').click();
      });

      const selectDropdowns = filters.querySelectorAll('select');
      if (selectDropdowns.length > 0) {
        selectDropdowns.forEach(item => {
          item.addEventListener('change', evt => {
            evt.target.closest('form').querySelector('input[type="submit"]').click();
          });
        });
      }
    }
  }
}

export default ResourcesFilter;
